// @ts-check

import loadPost from "./load-post"

export const loadLoadingPage = () => {
    loadPost("加载中…", "")
}

export default loadLoadingPage
